import { GroundSpeedSetup } from '../types/CalibrationParameters';

// Shown in place of the wheel circumference when a config takes its speed
// from GPS: the circumference is then not used for speed or distance.
export const GPS_CIRCUMFERENCE_LABEL = 'GPS';

type GpsSpeedFields = {
  ground_speed_setup?: GroundSpeedSetup | null;
  gps_speed?: boolean | null;
  wheel_circumference?: number | null;
};

/**
 * True when a config (or calibration) selects GPS as its speed source.
 *
 * Mirrors the server's CalibrationConst.gps_speed: an explicit
 * ground_speed_setup decides; otherwise the legacy gps_speed column; otherwise
 * the legacy wheel_circumference of -1.
 */
export function configUsesGpsSpeed(config: GpsSpeedFields | null | undefined): boolean {
  if (!config) return false;
  if (config.ground_speed_setup) return Boolean(config.ground_speed_setup.gps_speed);
  if (config.gps_speed != null) return config.gps_speed;
  const circumference = config.wheel_circumference;
  return circumference != null && circumference > -1.1 && circumference < -0.9;
}

/** Hover text for a circumference shown as GPS: the stored number, kept for when GPS is turned off. */
export function gpsCircumferenceTitle(circumference: number | null | undefined, places = 3): string {
  const kept = circumference != null && circumference > 0
    ? ` The stored ${circumference.toFixed(places)} m is kept for when GPS is turned off.` : '';
  return `Speed is from GPS for this config, so the wheel circumference is not used.${kept}`;
}
